export default function formatPhoneNumber(phoneNumber) {
    // Remove the +1 country code if present
    const cleaned = phoneNumber.startsWith('+1') ? phoneNumber.slice(2) : phoneNumber;
    // Remove any non-digit characters
    const digitsOnly = cleaned.replace(/\D/g, '');
    // Match and format the number in (123) 456-7890
    const match = digitsOnly.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber;
}
